import { render, staticRenderFns } from "./breadcrumbTrail.vue?vue&type=template&id=f7c0d42a&"
import script from "./breadcrumbTrail.vue?vue&type=script&lang=js&"
export * from "./breadcrumbTrail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports